<template>
  <v-btn
    :color="item.added ? 'error':'secondary'"
    @click="click()"
  >{{ item.added ? removeBtn:addBtn }}
    <v-icon dark>{{ item.added ? 'remove':'add' }}</v-icon>
  </v-btn>
</template>
<script>
export default {
    name: 'TwoStateButton',
    props: ['item'],
    computed:
          {
            removeBtn()
            {
              return this.$t('krita.remove');
            },
            addBtn()
            {
              return this.$t('krita.add');
            }
          },
    methods: {
        click ()
        {
            let self = this;

            console.log(self.item);
            self.$emit('changeState', self.item);
        },
    }
};
</script>

<style scoped>

</style>
